export const useStyles = theme => ({
    uploadComponent: {
        marginLeft: '50px',
    },
    imgPreview: {
        height: 49,
        width: 72,
    },
});